module.exports = __webpack_public_path__ + "static/mondays-main-f4e0dad55f5bce1fcc9b416d06ea2f82.svg";